// extracted by mini-css-extract-plugin
module.exports = {"break":"styles-module--break--2HexK","breadcrumbs":"styles-module--breadcrumbs--3dszn","device":"styles-module--device--t0Qxk","paragraph":"styles-module--paragraph--1brqb"};